import { render, staticRenderFns } from "./ArtiklModal.vue?vue&type=template&id=3706f726"
import script from "./ArtiklModal.vue?vue&type=script&lang=js"
export * from "./ArtiklModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports